import { Component, OnInit, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NoticiasService } from '../../core/noticias.service';
import { AuthService } from '../../core/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.css'],
  providers: [NgbCarouselConfig]

})
export class NoticiaComponent implements OnInit {
  id: string;
  noticia: any;
  maxCom = -6;
  revMax = 6;
  formulario: FormGroup;
  @ViewChild('panel') public panel: ElementRef;

  constructor(config: NgbCarouselConfig, public fb: FormBuilder, private authService: AuthService, private ns: NoticiasService, private activatedRoute: ActivatedRoute) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;

  }

  ngOnInit() {
    this.activatedRoute.params.forEach((urlParameters) => {
      this.id = urlParameters['id'];
      this.noticia = this.ns.getPorId(this.id).subscribe(noticia => this.noticia = noticia)
    });
    this.formulario = this.fb.group({
      'texto': ['', [Validators.required, Validators.minLength(1), Validators.maxLength(500)]],
    });
  }

  ngAfterViewInit() {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    // setTimeout(() =>
    //   this.panel.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    //   , 1000);

    // this.panel.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });

  }

  get texto() { return this.formulario.get('texto') }

  meGusta(arreglo: Array<any>, userId: string) {
    console.log(arreglo)
    arreglo.push({
      userId: userId,
      // numero: 3
    });

    this.ns.actualizar(this.id,
      { megusta: arreglo }
    );
  }

  eliminarMeGusta(arreglo: Array<any>, userId: string) {
    console.log(arreglo)
    arreglo = arreglo.filter(item => item.userId !== userId)

    this.ns.actualizar(this.id,
      { megusta: arreglo }
    );
  }

  checkMeGusta(arreglo: Array<any>, userId: string): boolean {
    return arreglo = arreglo.find(item =>
      item.userId == userId
    )
  }


  comentar(user: any, arreglo: Array<any>, ) {

    var texto_con_espacio = this.texto.value.replace(new RegExp('\n', 'g'), "<br>");

    arreglo.push({
      userId: user.uid,
      photoURL: user.photoURL,
      displayName: user.displayName,
      comentario: texto_con_espacio,
      fecha: new Date().getTime(),
      id: this.ns.crearId()
      // numero: 3
    });

    this.ns.actualizar(this.id,
      { comentarios: arreglo }
    );

    this.formulario.reset();

  }

  cargarMas() {
    this.maxCom = this.maxCom - 3;
    this.revMax = this.revMax + 3;
  }

  eliminarComentario(id: string, arreglo: Array<any>) {
    console.log(arreglo)
    arreglo = arreglo.filter(item => item.id !== id)

    this.ns.actualizar(this.id,
      { comentarios: arreglo }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/noticia/noticia.component.ts